export const ASSESSMENT_CONGRATULATION_REQUEST = "ASSESSMENT_CONGRATULATION_REQUEST";
export const ASSESSMENT_CONGRATULATION_RECEIVE = "ASSESSMENT_CONGRATULATION_RECEIVE";
export const ASSESSMENT_CONGRATULATION_FAILURE = "ASSESSMENT_CONGRATULATION_FAILURE";
export const RESET_ASSESSMENT_CONGRATULATION = "RESET_ASSESSMENT_CONGRATULATION";
